import { useFormikEnhanced } from '@superdispatch/forms';
import { useSnackbarStack } from '@superdispatch/ui';
import { Button } from '@superdispatch/ui-lab';
import { FormikProvider } from 'formik';
import { useMemo } from 'react';
import {
  setDriverPreferencesBusinessType,
  useDriverPreferences,
  useDriverPreferencesCacheUpdater,
} from 'shared/modules/driver/DriverPreferencesAPI';
import {
  DriverPreferencesBusinessTypeDTO,
  driverPreferencesBusinessTypeSchema,
} from 'shared/modules/driver/DriverPreferencesDTO';
import { trackDriverPreferences } from '../DriverPreferencesAnalytics';
import {
  DriverPreferencesStepItem,
  useDriverPreferencesStepperContext,
} from '../DriverPreferencesStepper';
import { BusinessTypeStepContent } from './BusinessTypeStepContent';

export function BusinessTypeStep() {
  const { handleNext } = useDriverPreferencesStepperContext();
  const { data } = useDriverPreferences();
  const { addSnackbar } = useSnackbarStack();

  const initialValues = useMemo(
    () => driverPreferencesBusinessTypeSchema.cast(data),
    [data],
  );

  const updateCache = useDriverPreferencesCacheUpdater();

  const formik = useFormikEnhanced<DriverPreferencesBusinessTypeDTO, unknown>({
    initialValues,
    validationSchema: driverPreferencesBusinessTypeSchema,
    onSubmit: (values) => {
      return setDriverPreferencesBusinessType(values);
    },
    onSubmitSuccess: (_, values) => {
      trackDriverPreferences({ name: 'Driver Completed Step 1 Business Type' });
      updateCache((cache) => {
        return { ...cache, ...values };
      });
      handleNext();
    },
    onSubmitFailure(error) {
      addSnackbar(error.message || 'Failed to save preferences', {
        variant: 'error',
        hasCloseButton: true,
      });
    },
  });
  const { isSubmitting } = formik;

  return (
    <FormikProvider value={formik}>
      <DriverPreferencesStepItem
        actions={
          <Button
            type="submit"
            pending={isSubmitting}
            fullWidth={true}
            onClick={() => {
              void formik.submitForm();
            }}
          >
            Continue
          </Button>
        }
      >
        <BusinessTypeStepContent />
      </DriverPreferencesStepItem>
    </FormikProvider>
  );
}
